import styled, { css } from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;

  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;

  padding-bottom: 8px;
  box-sizing: content-box;

  div {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 13px;
    font-weight: 400;
    padding: 8px 16px;
    border-right: 1px solid #ebeaf2;

    :hover {
      cursor: pointer;
      color: var(--accent-color);
    }
  }

  &::-webkit-scrollbar {
    height: 8px;
    padding-top: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
  }

`;

export const ToolbarItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
  ${({ isActive }) => isActive && css`
    color: var(--accent-color);
    font-weight: 700 !important;

    border-bottom: 2px solid var(--accent-color);
  `}
`;
